import axios from '@/libs/api.request'

export const getMenuList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/menu'
  })
}

export const getMenuTree = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/menu/tree'
  })
}

export const getPermissionList = (id) => {
  return axios.request({
    method: 'get',
    url: '/menu/permission/' + id
  })
}

export const getPermissionListNotIn = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/menu/permission/notIn/'
  })
}

export const getMenu = (id) => {
  return axios.request({
    method: 'get',
    url: '/menu/' + id
  })
}

export const addMenuPermission = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/menu/permission'
  })
}

export const delMenuPermission = (data) => {
  return axios.request({
    method: 'delete',
    data,
    url: '/menu/permission'
  })
}

export const addMenu = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/menu'
  })
}

export const editMenu = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/menu'
  })
}

export const delMenu = (id) => {
  return axios.request({
    method: 'delete',
    url: '/menu/' + id
  })
}
